<template lang="pug">
.primary.page-home-brands(v-if="items.length")
  .page-home-brands-title.text-body-1.text-sm-h6.text-center.white--text.mb-6.mb-sm-10.px-3.font-weight-bold.mx-auto
    .ubuntu {{ title }}
  grid-container.page-home-brands.px-8(
    v-if="xs",
    cols="repeat(3, calc((100% - 40px) / 3))",
    gap="20px"
  )
    brand(
      v-for="({ title, img }, i) in items",
      :key="i",
      :title="title",
      :img="files + img"
    )
  v-container.page-home-brands-list.d-flex.flex-column.flex-sm-row.flex-wrap.justify-center.align-center(
    v-else
  ) 
    brand(
      v-for="({ title, img }, i) in items",
      :key="i",
      :title="title",
      :img="files + img"
    )
</template>

<script>
import Brand from "../../cards/Brand.vue";

const _config = {
  mod: "brands",
  title:
    "Com a 1001 Representações você tem a disposição os melhores produtos das melhores marcas do mundo no ramo da construção civil.",
};

export default {
  data: () => ({
    title: _config.title,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  beforeCreate() {
    this.$rest(_config.mod).get();
  },
  components: {
    Brand,
  },
};
</script>

<style>
.page-home-brands {
  padding-top: 80px;
  padding-bottom: 80px;
}

.page-home-brands-title {
  max-width: 710px;
}
.page-home-brands-list.d-flex {
  gap: 32px 64px;
}
.page-home-brands-card {
  background-color: var(--v-secondary-base) !important;
}
@media screen and (max-width: 600px) {
  .page-home-brands {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
</style>